function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { Component } from 'react';
import Slider from 'react-slick';
import { NavLink } from './index';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import './commonCSS.css';
import mergeStyles from '../utils/StyleMerge';
import withSizes from '../utils/Sizes';

class ImageSlider extends Component {
  render() {
    const {
      styles,
      data,
      settings,
      sm,
      getStyle,
      history
    } = this.props;
    return (
      /*#__PURE__*/
      React.createElement("div", {
        style: getStyle(styles.container)
      },
      /*#__PURE__*/
      React.createElement(Slider, _extends({
        arrows: !sm
      }, settings), data.map((entry, index) => {
        const item = {
          url: entry.imageSliderItemUrl
        };

        if (entry.isEntry || item.url !== null) {
          return (
            /*#__PURE__*/
            React.createElement("div", {
              key: index,
              className: "sliderWrapper"
            },
            /*#__PURE__*/
            React.createElement(NavLink, {
              style: getStyle(styles.navLink),
              history: history,
              useRouter: entry.isEntry,
              item: item
            },
            /*#__PURE__*/
            React.createElement("img", {
              src: entry.imageSliderItemImage[0].url,
              alt: 'img'
            })))
          );
        } else {
          return (
            /*#__PURE__*/
            React.createElement("div", {
              key: index,
              className: "sliderWrapper"
            },
            /*#__PURE__*/
            React.createElement("div", {
              style: getStyle(styles.item)
            },
            /*#__PURE__*/
            React.createElement("img", {
              src: entry.imageSliderItemImage[0].url,
              alt: 'img'
            })))
          );
        }
      })))
    );
  }

}

ImageSlider.defaultProps = {
  settings: {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 3,
    autoplay: false,
    centerMode: false
  }
};
const defaultStyles = {
  container: {
    width: '100%',
    maxWidth: 1200,
    backgroundColor: 'tan',
    display: 'flex',
    alignItems: 'center',
    padding: 100,
    overflow: 'hidden'
  },
  navLink: {
    padding: 0
  }
};
export default mergeStyles(defaultStyles)(withSizes(ImageSlider));